import { ConfigInterface } from 'swr';
import { useApi } from '@gik/core/api';
import IConfig from '@gik/core/models/gik/IConfig';

const path = 'config';

export function useConfig(config?: ConfigInterface) {
  return useApi<IConfig>(path, config);
}
